import { render, staticRenderFns } from "./CampaignConfigurationList.vue?vue&type=template&id=01f900b1&lang=pug&"
import script from "./CampaignConfigurationList.vue?vue&type=script&lang=js&"
export * from "./CampaignConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports